<template>
  <div class="vida-register-page">
    <div class="vida-register-overlay">
      <div class="vida-register">
        <van-nav-bar class="vida-register-nav">
          <template #left>
            <img class="vida-register-back" :src="backIcon" alt="" @click="back">
          </template>
        </van-nav-bar>

        <div class="vida-register-wrapper">
          <div class="vida-register-heading">
            <div class="vida-register-brand">Love Light</div>
            <div class="vida-register-title">{{ $t('appUi.register') }}</div>
          </div>
          <form class="vida-register-form" @submit.prevent="doRegister">
            <van-field
              v-model.trim="username"
              class="vida-register-input"
              type="text"
              input-align="center"
              autocomplete="username"
              :placeholder="$t('appUi.usernamePlaceholder')"
            />
            <div class="vida-register-hint">
              {{ $t('appUi.usernameHint') }}
            </div>

            <van-field
              v-model="password"
              class="vida-register-input"
              :type="passwordType"
              input-align="center"
              autocomplete="new-password"
              :placeholder="$t('appUi.passwordPlaceholder')"
              :right-icon="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
              @click-right-icon="switchPasswordType"
            />
            <div class="vida-register-hint">
              {{ $t('appUi.passwordHint') }}
            </div>

            <van-field
              v-model.trim="code"
              class="vida-register-input"
              type="text"
              input-align="center"
              autocomplete="off"
              :placeholder="$t('appUi.invitationPlaceholder')"
            />
            <div class="vida-register-hint">
              {{ $t('appUi.invitationHint') }}
            </div>

            <div class="vida-register-agreement">
              <van-checkbox v-model="checked" shape="round" />
              <span>{{ $t('appUi.agreement') }}</span>
            </div>

            <van-button
              class="vida-register-button"
              native-type="submit"
              type="primary"
              :loading="isLoading"
            >
              {{ $t('appUi.registerSubmit') }}
            </van-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import backIcon from '@/assets/img/vida-login/download.png'

export default {
  name: 'Register',
  data() {
    return {
      username: '',
      password: '',
      passwordType: 'password',
      code: '',
      checked: true,
      isLoading: false,
      backIcon
    }
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back() {
      if (window.history.length > 1) this.$router.go(-1)
      else this.$router.push('/Login')
    },
    async doRegister() {
      if (this.isLoading) return
      if (!this.username || this.username.length < 6 || this.username.length > 20) {
        this.$toast(this.$t('appUi.usernameLength'))
        return
      }
      if (!/^[A-Za-z0-9]+$/.test(this.username)) {
        this.$toast(this.$t('appUi.usernameFormat'))
        return
      }
      if (!this.password || this.password.length < 6 || this.password.length > 16) {
        this.$toast(this.$t('appUi.passwordLength'))
        return
      }
      if (!this.code) {
        this.$toast(this.$t('register.codePls'))
        return
      }
      if (!this.checked) {
        this.$toast(this.$t('register.xieyiPls'))
        return
      }

      this.isLoading = true
      try {
        const res = await this.$http({
          method: 'post',
          url: 'member_register',
          data: {
            username: this.username,
            password: this.password,
            paypassword: this.password,
            code: this.code,
            lang: this.$i18n.locale
          }
        })

        if (res.code === 200 || res.code === 0) {
          this.$toast.success(res.msg || this.$t('appUi.registrationSuccess'))
          const token = res.data && typeof res.data === 'object'
            ? (res.data.id || res.data.token)
            : res.data
          if (token) this.$store.commit('setToken', token)
          if (res.data && typeof res.data === 'object') this.$store.commit('setUserInfoValue', res.data)
          this.$router.push(token ? '/Mine' : '/Login')
          return
        }

        this.$toast.fail(res.msg || this.$t('appUi.registrationFailed'))
      } catch (error) {
        this.$toast.fail(this.$t('appUi.registrationRequestFailed'))
      } finally {
        this.isLoading = false
      }
    }
  },
  created() {
    if (localStorage.getItem('token')) this.$router.replace('/Mine')
  },
  mounted() {
    this.$nextTick(() => {
      if (window.startLoginBackground) window.startLoginBackground()
    })
  },
  beforeDestroy() {
    if (window.stopLoginBackground) window.stopLoginBackground()
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/basenew.css";

.vida-register-page {
  position: fixed;
  inset: 0;
  z-index: 1000;
  width: 100%;
  height: var(--app-height, 100vh);
  min-height: 0;
  overflow: hidden;
  background: transparent;
  font-size: 16PX;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "Segoe UI", Arial, Roboto, "PingFang SC", miui, "Hiragino Sans GB", "Microsoft Yahei", sans-serif;
}

.vida-register-overlay {
  position: absolute;
  inset: 0;
}

.vida-register-overlay {
  background: rgba(0, 0, 0, .51);
}

.vida-register,
.vida-register-wrapper {
  height: 100%;
}

.vida-register,
.vida-register-back,
.vida-register-brand,
.vida-register-title,
.vida-register-form,
.vida-register-form input,
.vida-register-form button,
.vida-register-hint,
.vida-register-agreement {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "Segoe UI", Arial, Roboto, "PingFang SC", miui, "Hiragino Sans GB", "Microsoft Yahei", sans-serif;
}

.vida-register-wrapper {
  display: flex;
  min-height: 0;
  flex-direction: column;
  justify-content: center;
  padding: calc(13.333vw + env(safe-area-inset-top)) 0 4vw;
  box-sizing: border-box;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
}

@media screen and (max-height: 700px) {
  .vida-register-wrapper { justify-content:flex-start; padding-top:calc(52px + env(safe-area-inset-top)); padding-bottom:24px; }
  .vida-register-brand { font-size:clamp(32px,9vw,44px); }
  .vida-register-title { padding-top:8px; }
  .vida-register-form { padding-top:6px; }
  .vida-register-input { margin-top:10px; padding-top:10px; padding-bottom:10px; }
}

.vida-register-nav {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  left: 0;
  height: 13.333vw;
  background: transparent;
  border-bottom: 1px solid transparent;
}

.vida-register-back {
  width: 20PX;
  height: 15PX;
  cursor: pointer;
}

.vida-register-language {
  position: absolute;
  top: 1.333vw;
  right: 5.333vw;
  width: 5.7841vw;
  height: 8.267vw;
  line-height: 6.667vw;
  cursor: pointer;
}

.vida-register-language img {
  width: auto;
  height: 70%;
}

.vida-register-heading {
  text-align: center;
}

.vida-register-brand {
  color: #f4d49a;
  font-size: 10vw;
  font-weight: 700;
  letter-spacing: .08em;
  text-shadow: 0 3px 14px rgba(0, 0, 0, .6);
}

.vida-register-title {
  padding-top: 2.4vw;
  color: #ccc;
  font-size: 3.733vw;
}

.vida-register-form {
  padding: 2.667vw 8vw;
}

.vida-register-input {
  width: 100% !important;
  height: auto;
  box-sizing: border-box;
  margin-top: 3.2vw;
  padding: 3.467vw 2.667vw;
  border: .267vw solid #766350;
  border-radius: 1.333vw;
  color: #e6b98a;
  background: linear-gradient(120deg, #212121, #313131);
  font-size: 4vw;
  text-align: center;
}

.vida-register-hint {
  margin: 1.067vw 2.667vw 0;
  color: #c5c5c5;
  font-size: 2.933vw;
  line-height: 1.35;
}

.vida-register-agreement {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4.267vw;
  padding: 0 1.6vw;
}

.vida-register-agreement > span {
  margin-left: 2.133vw;
  color: #fff;
  font-size: 3.333vw;
  line-height: 4.4vw;
  text-align: left;
}

.vida-register-button {
  width: 100%;
  height: 10.667vw;
  margin-top: 5.333vw;
  border: 0;
  border-radius: 6.667vw;
  color: #68302c;
  background: linear-gradient(#fde3ca, #e7b486);
  font-size: 4vw;
  font-weight: 700;
}

.vida-register-page /deep/ .van-nav-bar__content {
  height: 13.333vw;
}

.vida-register-page /deep/ .van-nav-bar__left {
  padding: 0 4vw;
}

.vida-register-page /deep/ .van-nav-bar__right {
  padding: 0 2.133vw;
}

.vida-register-page /deep/ .van-cell::after {
  display: none;
}

.vida-register-page /deep/ .van-field__control {
  height: 4.7273vw;
  color: #e6b98a;
}

.vida-register-page /deep/ .van-field__control::placeholder {
  color: #c8c9cc;
  opacity: 1;
}

.vida-register-page /deep/ .van-field__right-icon {
  margin-right: -1.067vw;
  padding: 0 1.067vw;
}

.vida-register-page /deep/ .van-field__right-icon .van-icon {
  color: #969799;
  font-size: 6.667vw;
}

.vida-register-page /deep/ .vida-register-agreement .van-checkbox__icon {
  font-size: 5.067vw;
}

.vida-register-page /deep/ .vida-register-agreement .van-checkbox__icon--checked .van-icon {
  color: #fff;
  border-color: #d7aa68;
  background-color: #8b6844;
}

@media screen and (min-width: 1024px) {
  .vida-register-page {
    width: 430PX;
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }

  .vida-register-wrapper { padding: 60PX 0 24PX; }
  .vida-register-nav { height: 50PX; }
  .vida-register-page /deep/ .van-nav-bar__content { height: 50PX; }
  .vida-register-page /deep/ .van-nav-bar__left { padding: 0 14PX; }
  .vida-register-language { top: 5PX; right: 20PX; width: 24PX; height: 40PX; line-height: 32PX; }
  .vida-register-language img { height: 70%; }
  .vida-register-brand { font-size: 42PX; }
  .vida-register-title { padding-top: 10PX; font-size: 14PX; }
  .vida-register-form { padding: 10PX 20PX; }
  .vida-register-input {
    display: flex;
    align-items: center;
    height: 60PX;
    margin-top: 14PX;
    padding: 0 14PX;
    border-width: 1PX;
    border-radius: 8PX;
    font-size: 16PX;
  }
  .vida-register-hint { margin: 6PX 12PX 0; font-size: 12PX; line-height: 17PX; }
  .vida-register-agreement { margin-top: 18PX; padding: 0 8PX; }
  .vida-register-agreement > span { margin-left: 10PX; font-size: 14PX; line-height: 20PX; }
  .vida-register-button { height: 50PX; margin-top: 22PX; font-size: 16PX; }
  .vida-register-page /deep/ .vida-register-agreement .van-checkbox__icon { font-size: 20PX; }
  .vida-register-page /deep/ .van-field__body { width: 100%; }
  .vida-register-page /deep/ .van-field__control { height: 24PX; line-height: 24PX; }
  .vida-register-page /deep/ .van-field__right-icon .van-icon { font-size: 20PX; }
}
</style>

<style lang="less">
.vida-register-language-popover.van-popover {
  width: 96PX !important;
  max-height: none !important;
}

.vida-register-language-popover .van-popover__content {
  max-height: none !important;
  overflow: hidden !important;
  border-radius: 4PX !important;
}

.vida-register-language-popover .van-popover__action {
  width: 96PX !important;
  height: 29PX !important;
  padding: 0 6PX !important;
  font-size: 11PX !important;
  line-height: 29PX !important;
}

.vida-register-language-popover .van-popover__action-text {
  font-size: 11PX !important;
  line-height: 29PX !important;
  white-space: nowrap !important;
}

.vida-register-language-popover .van-popover__arrow {
  border-width: 6PX !important;
}
</style>
